import React, {FC, ReactChild} from "react"
import styled, {css} from "styled-components"
import {omit} from "lodash"

import id from "@irati/utils/id"

import {IconProps} from "../index"
import {spacingCss, SpacingProps} from "../../global/css"

interface SvgProps extends IconProps, SpacingProps {
  color?: string
  id?: string
  className?: string
  viewBox?: string
}

const StyledSvg = styled.svg<SvgProps>`
  ${({size, color}) => css`
    font-size: ${size || 14}px;
    path {
      fill: ${color};
    }
  `}
  ${spacingCss}
`

export interface BaseProps extends SvgProps {
  children?: ReactChild
}
const Base: FC<BaseProps> = (props) => {
  const idNamespace = id("svg", props)
  const {className, viewBox, size, children, ...rest} = props
  return (
    <StyledSvg
      id={idNamespace}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox || "0 0 20 20"}
      width={size}
      height={size}
      preserveAspectRatio="xMidYMid"
      {...omit(rest, ["id"])}>
      {children}
    </StyledSvg>
  )
}

export default Base
